import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function Contact() {
  const [isLoading, setIsLoading] = useState(true);
  const [Project1, setProject1] = useState(null);
  const location = useLocation().pathname.split("/")[2];

  useEffect(() => {
    setIsLoading(true);
    import('./detail/index.js')
      .then((module) => {
        setProject1(() => module.default);
      })
      .catch((err) => {
        console.error('Failed to load project:', err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <div>
        {isLoading && (
        <div className="flex items-center justify-center py-10">
          <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
        </div>
      )}

      {!isLoading && Project1 && (
        <Project1 data={location} />
      )}
      {/* {Project1 ? <Project1 data={location} /> : <p>Loading project...</p>} */}
    </div>
  );
}

export default Contact;